<template>
  <div class="verval">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text"> <strong>Kelola Kelas</strong> Pelatihan Pengimbasan </h1>
            <div>
              Modul ini digunakan untuk melakukan Kelola Kelas Pelatihan Pengimbasan Sekolah Penggerak yang terdiri dari
              Peserta dan Narasumber
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat>
      <v-card-text class="pa-0">
        <div class="mx-4 py-4">
          <h3 class="black--text">Daftar Kelas Pelatihan</h3>
        </div>
        <v-divider />
        <base-table-header
          outlined-button
          :options="{ header: 'py-2' }"
          :btnAdd="false"
          :btnDownload="false"
          @reload="onReload"
          @search="onSearch"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
          <template v-slot:toolbarAfter>
            <v-btn
              v-if="$allow('psp-pelatihan-imbas-kelas.create')"
              color="primary"
              class="ml-2"
              depressed
              @click="onAdd"
            >
              <v-icon left dark class="mr-1">
                mdi-plus
              </v-icon>
              Kelas
            </v-btn>
          </template>
        </base-table-header>
        <v-divider />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          :emptyMsg="`Anda tidak memiliki data kelas pelatihan pengimbasan`"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-google-classroom</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-row no-gutters>
                      <v-col cols="12" md="4">
                        <div class="text-body-1 font-weight-medium">{{ item.nama }}</div>
                        <div class="caption">
                          <span class="grey--text text--darken-1">Terakhir diubah:</span>
                          {{ $localDate($getDeepObj(item, 'updated_at'), false, true) }} WIB
                        </div>
                        <div class="caption">
                          <span class="grey--text text--darken-1">oleh:</span>
                          {{ $getDeepObj(item, 'akun.nama') }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-label color="caption"><small>Peserta Kelas </small></v-label>
                        <div class="mt-1">
                          <v-chip :color="$getDeepObj(item, 'status_lengkap.peserta') ? 'green' : 'grey'" dark>
                            {{ $getDeepObj(item, 'status_lengkap.peserta') ? 'Lengkap' : 'Belum Lengkap' }}
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-label color="caption"><small>Narasumber</small></v-label>
                        <div class="mt-1">
                          <v-chip :color="$getDeepObj(item, 'status_lengkap.narasumber') ? 'green' : 'grey'" dark>
                            {{ $getDeepObj(item, 'status_lengkap.narasumber') ? 'Lengkap' : 'Belum Lengkap' }}
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content class="py-0">
                            <v-list-item-title>
                              <v-label color="caption"><small>Aksi</small></v-label>
                            </v-list-item-title>
                            <v-list-item-subtitle class="link black--text body-2">
                              <v-btn depressed small dark color="blue" @click="onDetail(item)" class="text-capitalize">
                                Lihat Detail
                              </v-btn>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                  </v-list-item-action-text>
                </v-list-item>
              </v-list>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full ref="modal" :title="formulir.title" @save="onSave">
      <form-kelas ref="formulir" :initValue="formulir.init" :masters="masters" />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import actions from './actions';
import FormKelas from './form/Kelas.vue';

export default {
  name: 'KelasIndex',
  components: { FormKelas },
  mixins: [list],
  data() {
    return {
      actions: actions,
      formulir: {},
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),
  },
  async created() {
    await this.getMasters(['propinsi', 'kota'].join(';'));
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('pengimbasanKelas', ['fetch', 'action']),

    allow(action, data) {
      let allow = this.$allow(action.akses, data.policies);
      switch (action.event) {
        case 'onViewNilai':
          allow =
            allow &&
            this.$getDeepObj(data, 'status_lengkap.peserta') &&
            this.$getDeepObj(data, 'status_lengkap.narasumber');
          break;
      }
      return allow;
    },

    onAdd() {
      this.$set(this.formulir, 'title', 'Tambah Kelas Pelatihan');
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onDetail(item) {
      this.$router.push({
        name: 'pengimbasan-kelas-detail',
        params: { kelas_id: item.psp_pelatihan_kelas_id },
      });
    },

    onViewNilai(item) {
      this.$router.push({
        name: 'pengimbasan-kelas-nilai',
        params: { kelas_id: item.psp_pelatihan_kelas_id },
      });
    },

    onDelete(item) {
      this.$confirm(`Anda yakin ingin menghapus kelas <strong>${item.nama}?</strong>`, 'Hapus kelas', {
        tipe: 'error',
      }).then(() => {
        this.action({ id: item.psp_pelatihan_kelas_id, endpoint: 'delete' }).then(() => {
          this.onReload();
          this.$success('Kelas berhasil dihapus');
        });
      });
    },

    onSave() {
      const values = this.$refs.formulir.getValue();

      this.action({ endpoint: 'create', params: values })
        .then(({ kelas }) => {
          this.$success('Kelas baru berhasil ditambahkan');
          this.$refs.modal.close();

          this.onDetail(kelas);
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
